export const utm_type = {
    UTM_PARAM_CAMPAIGN: "campaign",
    UTM_PARAM_MEDIUM: "medium",
    UTM_PARAM_SOURCE: "source",
}
